@import "https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;700&family=Roboto+Condensed:wght@400;500;600;700&display=swap";

/* src/app/core/pages/login/login.page.scss */
:root {
  --poppins-font: "Poppins", sans-serif;
  --roboto-font: "Roboto Condensed", sans-serif;
}
.w-35px {
  width: 35px;
}
.w-70px {
  width: 70px;
}
.mt-n-3px {
  margin-top: -3px;
}
.mt-n-12px {
  margin-top: -12px;
}
.text-color-secondary {
  color: var(--ion-color-secondary);
}
.border-radius-20px {
  --border-radius: 20px !important;
}
.bg-color-1283f1 {
  --background: #1283f1 !important;
}
.title {
  font-family: "Staatliches";
  color: var(--ion-color-secondary);
  letter-spacing: 5px;
}
.title .dine {
  color: var(--ion-color-tertiary);
}
.login-page-card {
  background:
    linear-gradient(
      to bottom,
      #4DA0B0,
      #D39D38) 0% 0% no-repeat padding-box;
  border-radius: 20px;
  border: 1.5px solid #ccffcc;
  box-sizing: border-box;
  box-shadow: 10px 4px 10px rgba(0, 0, 0, 0.1411764706);
}
.login-page-card .login-form-section .form-title {
  font-size: 24px;
  font-family: var(--poppins-font);
  font-weight: 700;
  line-height: 28px;
  color: #ffd949;
}
.login-page-card .login-form-section .form-subtitle {
  font-size: 14px;
  font-family: var(--roboto-font);
  font-weight: 600;
  line-height: 21px;
  color: #fbfbfb;
}
.login-form-section .form-inputs {
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 20px;
  height: 35px;
  box-shadow: 2px 2px 4px hsla(0, 0%, 0%, 0.157);
}
.form-inputs .form-input-icon {
  font-size: 20px;
  color: #31b7c2;
  font-family: var(--roboto-font);
}
.login-form-section .forget-pwd-link {
  font-size: 14px;
  font-family: var(--poppins-font);
  font-weight: 600;
  color: #f2f2f5;
}
.login-form-section .forget-pwd-link :hover {
  cursor: pointer;
  color: #1283f1 !important;
  text-decoration: underline !important;
}
.error-message {
  font-size: 14px;
  font-weight: 600;
  font-family: var(--roboto-font);
  white-space: wrap !important;
  color: #db0f0f;
  border-radius: 6px !important;
}
ion-radio {
  --color-checked: #f15959 !important;
  --color: #ffffff !important;
  width: 16px !important;
  height: 16px !important;
}
ion-label.login-type {
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  font-family: var(--roboto-font);
}
/*# sourceMappingURL=login.page.css.map */
